app.service('basketServices', function (console, loading, modal, log, broker, updateExcludedServices) {
	var selectedService, removeModal, counter = 0, savedAdded = {};
	var $inputs, $confirm, $inputsAndSelects;

	function count() {
		return counter;
	}

	function increase(productId, serviceId, quantity, productQuantity) {
		if (quantity < productQuantity) {
			update('add-single', {
				mainItemId: productId,
				serviceId: serviceId,
				addedFrom: 'CART_EDIT'
			});
		}
	}
	function decrease(productId, serviceId, quantity) {
		if (quantity > 1) {
			update('remove-single', {
				mainItemId: productId,
				serviceId: serviceId,
				addedFrom: 'CART_EDIT'
			});
		}
	}
	function confirmRemove() {
		console.log('USUWANIE USLUGI');

		var service = $('input[type=checkbox].js-delete-service[data-service=' + selectedService.serviceId + ']');
		service.prop('checked', false);

		update('remove', {
			mainItemId: selectedService.mainItemId,
			servicesIds: selectedService.serviceId,
			addedFrom: 'CART_EDIT'
		});
	}
	function remove(mainItemId, serviceId) {
		selectedService = {
			mainItemId: mainItemId,
			serviceId: serviceId
		};
		if (!removeModal) {
			removeModal = modal.open('delete-service-message');
		} else {
			removeModal.open();
		}
	}
	function add(options) {
		counter++;
		console.log('DODANIE USŁUGI - ' + options.serviceId + ' - DO PRODUKTU - ' + options.mainItemId);
		update('add', {
			mainItemId: options.mainItemId,
			servicesIds: options.serviceId,
			addedFrom: 'CART_EDIT',
			noReload: options.noReload
		}, options.callback);
	}
	function removeFromModal(options) {
		counter--;
		console.log('USUWANIE USŁUGI - ' + options.serviceId + ' - DO PRODUKTU - ' + options.mainItemId);
		update('remove', {
			mainItemId: options.mainItemId,
			servicesIds: options.serviceId,
			addedFrom: 'CART_EDIT',
			noReload: options.noReload
		}, options.callback);
	}
	function update(action, options, callback) {
		loading.start();
		modal.close();
		var url = '';
		if (action == 'add') {
			url = '/add-services-to-cart.ltr';
		} else if (action == 'add-single') {
			url = '/increase-services-quantity-in-cart.ltr';
		} else if (action == 'remove-single') {
			url = '/decrease-services-quantity-in-cart.ltr';
		} else if (action == 'remove') {
			url = '/remove-services-from-cart.ltr';
		} else if (action == 'change') {
			url = '/change-services-quantity-in-cart.ltr';
		}
		$.ajax({
			url: url,
			type: 'POST',
			data: options,
			cache: false,
			success: function () {
				if (!options.noReload) {
					document.location.reload();
				} else {
					loading.stop();
					if (callback) {
						callback();
					}
				}
			},
			error: function () {
				loading.stop();
				modal.alert('Błąd operacji na usługach. Prosimy spróbować później', function () {
					broker.trigger('REFRESH_BASKET_VIEW');
				})
			}
		});
	}
	function change(data) {
		update('change', data);
	}
	function info(serviceId, productId) {
		loading.start();
		$.ajax({
			url: '/service-front-view.ltr',
			data: {
				rwd: true,
				serviceId: serviceId,
				productId: productId
			},
			success: function (html) {
				loadSuccess(html);
			},
			error: function () {
				loadError();
			}
		});
	}
	function save() {
		var added = [];
		var removed = [];
		var updated = [];
		$inputs.each(function () {
			var $this = $(this);
			var checked = $this.is(':checked');
			var value = $this.val();
			var plu = $this.data('plu');
			var newQuantity = $this.parent().find('.js-service-quantity').val();
			var oldQuantity = addedQuantity(value);
			if (oldQuantity > 0 && !checked) {
				removed.push({ id: value, plu: plu });
			} else if (newQuantity > oldQuantity && checked) {
				added.push({ id: value, quantity: newQuantity, plu: plu });
			} else if (newQuantity != oldQuantity && oldQuantity > 0 && checked) {
				updated.push({ id: value, quantity: newQuantity, plu: plu });
			}
		});
		function endSelected() {
			modal.close();
			broker.trigger('REFRESH_BASKET_VIEW');
		}
		function addSelected() {
			var a = added.shift();
			console.log('adding service', a , savedAdded.paymentType);
			log.event({
				id: 'to_cart',
				f03: 'cart_step_1',
				f04: parseInt(a.plu),
				f05: 'service',
				f06: savedAdded.productPlu,
				f07: 'services_details',
				f08: 'fancybox',
				f09: 'new',
				f10: savedAdded.paymentType,
			});
			$.ajax({
				url: '/cart-item-operation.ltr',
				type: 'POST',
				data: {
					mainCartItemId: savedAdded.mainItemId,
					action: 'ADD_PRODUCT_SERVICE',
					addedFrom: 'CART_EDIT',
					serviceId: a.id,
					serviceQuantity: a.quantity
				},
				cache: false,
				success: function () {
					run();
				},
				error: function () {
					modal.alert('Błąd dodawania usługi. Prosimy spróbować później', function () {
						broker.trigger('REFRESH_BASKET_VIEW');
					});
				}
			});
		}
		function removeSelected() {
			removed.forEach(element => {
				log.event({
					id: 'remove_cart',
					f03: 'cart_step_1',
					f04: element.plu,
					f05: 'service',
					f06: savedAdded.productPlu,
					f07: 'services_details',
					f08: 'fancybox',
					f09: 'new',
					f10: savedAdded.paymentType
				});
			});
			update('remove', {
				mainItemId: savedAdded.mainItemId,
				servicesIds: removed.map((i) => i.id),
				noReload: true,
				addedFrom: 'CART_EDIT'
			}, function () {
				removed = [];
				run();
			});
		}
		function updateSelected() {
			var t = updated.shift();
			update('change', {
				mainItemId: savedAdded.mainItemId,
				serviceId: t.id,
				quantity: t.quantity,
				noReload: true,
				addedFrom: 'CART_EDIT'
			}, function () {
				run();
			});
		}
		function run() {
			if (removed.length) {
				removeSelected();
			} else if (updated.length) {
				updateSelected();
			} else if (added.length) {
				addSelected();
			} else {
				endSelected();
			}
		}
		run();
	}
	function addedQuantity(value) {
		var addedQuantity = savedAdded.added.filter((e) => {
			return e.id == value
		})
		return addedQuantity.length ? addedQuantity[0].quantity : 0;
	}

	function open(params) {
		savedAdded = params;
		var content = $('#basket-service-' + params.mainItemId + '-' + params.index).html();
		$modal = modal.generate({
			overwrite: true,
			id: 'modal-basket-service',
			content: content,
			modifier: 'remodal-full-width services-list',
			callbackOpen: function () {
				$confirm = $('#modal-basket-service .js-service-change-confirm');
				$inputs = $('#modal-basket-service input:checkbox');
				$inputsAndSelects = $('#modal-basket-service').find('.js-service-quantity, input:checkbox');
				$inputsAndSelects.change((el) => {
					$confirm.removeAttr('disabled');
					updateExcludedServices.run({
						$input: $(el.target),
						$inputs: $inputs
					});
				});
			}
		});
	}
	return {
		change,
		open,
		save,
		increase: increase,
		decrease: decrease,
		count: count,
		info,
		remove: remove,
		confirmRemove: confirmRemove,
		add: add,
		removeFromModal: removeFromModal
	};
});
